module.exports = __webpack_public_path__ + "static/img/refresh.a276ef17.png";